import { clsx } from 'clsx';

export interface LoadingSpinnerProps {
  size?: 'sm' | 'md' | 'lg';
  className?: string;
  /** If true, centers the spinner in a flex container with padding */
  centered?: boolean;
}

export function LoadingSpinner({
  size = 'md',
  className = '',
  centered = true,
}: LoadingSpinnerProps) {
  const sizeClasses = {
    sm: 'h-4 w-4',
    md: 'h-8 w-8',
    lg: 'h-12 w-12',
  };

  const spinner = (
    <div
      className={clsx(
        'animate-spin rounded-full border-b-2 border-[#3C5FA8]',
        sizeClasses[size],
        className
      )}
    />
  );

  if (centered) {
    return <div className="flex items-center justify-center p-4">{spinner}</div>;
  }

  return spinner;
}
